// Razorpay's checkout.js is included via a <script> tag in public/index.html.
// This helper waits for it in case this component mounts before that
// script finishes loading (slow network, etc.), instead of assuming it's ready.
export function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(window.Razorpay);

    const existing = document.querySelector('script[src*="checkout.razorpay.com"]');
    const script = existing || document.createElement("script");

    if (!existing) {
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      document.body.appendChild(script);
    }

    script.addEventListener("load", () =>
      window.Razorpay ? resolve(window.Razorpay) : reject(new Error("Razorpay failed to initialize."))
    );
    script.addEventListener("error", () => reject(new Error("Could not load Razorpay checkout.")));

    // Already attached & loaded by the time we get here in most cases.
    if (window.Razorpay) resolve(window.Razorpay);
  });
}
